import { useState } from "react";
import { api, extractAxiosError } from "../lib/api";
import { Loader2 } from "lucide-react";

export function CreateOrganisationForm({ onCreated }) {
    const [name, setName] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) return;
        setBusy(true);
        setErr("");
        try {
            await api.post("/orgs", { name: name.trim() });
            onCreated?.();
        } catch (ex) {
            setErr(extractAxiosError(ex, "Could not create organisation"));
        } finally {
            setBusy(false);
        }
    };

    return (
        <form onSubmit={onSubmit} className="mt-6 max-w-sm mx-auto space-y-3" data-testid="create-org-form">
            <label className="block text-left">
                <span className="label-eyebrow">Organisation name</span>
                <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    className="input-dark mt-2 w-full rounded-md px-4 py-2.5"
                    placeholder="My Company"
                    data-testid="create-org-name"
                />
            </label>
            {err && <p className="text-sm text-rose-400" data-testid="create-org-error">{err}</p>}
            <button
                type="submit"
                disabled={busy || !name.trim()}
                className="btn-neon w-full rounded-md py-2.5 text-sm font-semibold inline-flex items-center justify-center gap-2"
                data-testid="create-org-submit"
            >
                {busy && <Loader2 className="h-4 w-4 animate-spin" />}
                Create organisation
            </button>
        </form>
    );
}
